const config = {
    endpoint: `https://auth-hr-fyak.onrender.com/api`
    //endpoint: `http://localhost:8082/api`
};

export default config;